// extracted by mini-css-extract-plugin
module.exports = {"text":"_2XEIBgdaUA18gDCZ5sQq3B","expanded":"_38VTDnVW-zN3Zs90BGH9Ie","viewMore":"_1n9MIFZmE8j8Y1oxqP5ulf"};